'use client'

import classNames from 'classnames'
import React from 'react'

import CmsImage from '~/components/cms-image'
import { ISlideIconItem } from '~/types/strapi'

const SliderItem: React.FC<ISlideIconItem> = ({
  description,
  image,
  title,
}) => {
  return (
    <div className="flex flex-col justify-center items-center gap-4 text-center p-6">
      <CmsImage
        attributes={image.data.attributes}
        className="w-20 h-20 object-contain object-center"
      />
      <strong
        className={classNames(
          'text-xl md:text-mobile-3xl text-balance font-sans-16 leading-[1.2]'
        )}
      >
        {title}
      </strong>
      <p className="text-base leading-[1.4]">{description}</p>
    </div>
  )
}

export default SliderItem
